import { createObjectUrlFromStoredAsset } from './localAssetStore';
import { hasPhotoSessionUrl } from './photoSession';
import type { CalendarProject } from '../types/calendarProject';

export type ResolvedPhotoPreview = {
  url: string | null;
  shouldRevoke: boolean;
  source: 'session' | 'indexeddb' | 'missing';
};

export async function resolvePhotoPreviewUrl(project: CalendarProject, photoId: string): Promise<ResolvedPhotoPreview> {
  const photo = project.photos.find((item) => item.id === photoId);

  if (photo?.objectUrl && hasPhotoSessionUrl(photo.objectUrl)) {
    return { url: photo.objectUrl, shouldRevoke: false, source: 'session' };
  }

  try {
    const storedObjectUrl = await createObjectUrlFromStoredAsset(project.id, photoId, photo?.localAssetKey);
    if (storedObjectUrl) return { url: storedObjectUrl, shouldRevoke: true, source: 'indexeddb' };
  } catch {
    // Fallback řeší UI komponenty; IndexedDB může být v anonymním režimu nedostupné.
  }

  return { url: null, shouldRevoke: false, source: 'missing' };
}
